<ng-container *ngIf="formFieldConfig.type === 'google'" [formGroup]="formGroup">
    <!-- <app-form-label [labelData]="formFieldConfig.label!"></app-form-label> -->
    <div class="list">
        <input (input)="keyPress()" [name]="formFieldConfig.name" [(ngModel)]="placeInsertedByUser"          
            [formControlName]="formFieldConfig.formControlName" [placeholder]=""
            autocomplete="off" />
        <ng-container *ngIf="isOptionsVisible && formFieldConfig.type === 'google'">
            <ul class="list__container">
                <li class="list__container-item" *ngFor="let option of formFieldConfig.options"
                    (click)="onOptionSelected(option)">
                    {{ option.description }}
                </li>
            </ul>
        </ng-container>
    </div>
</ng-container>